import React, { useState, useEffect, useRef } from 'react';
/** Components Import */
import { Box, Stack, Typography, TextField, IconButton } from '@mui/material';
import { Button } from '../../Components/MUIs';
/** Icons Import */
import { NavigateBefore as BackIcon } from '@mui/icons-material';

function Certification(props) {
  return (
    <Box>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          width: '100%',
          marginTop: '10px',
          marginBottom: '50px',
        }}
      >
        <IconButton
          onClick={() => {
            props.setCertificationInputs({
              ...props.certificationInputs,
              passwoard: '',
            });
            props.setSettingToggle(false);
          }}
        >
          <BackIcon fontSize="large" />
        </IconButton>
        <div style={{ width: '10%' }} />
      </div>
      <Stack
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          p: 2,
        }}
        spacing={2}
      >
        <Typography variant="h5">
          {props.lanInfo.length > 0
            ? props.lanInfo.filter(
                (f) => f.lanId === 'PleaseEnterYourPassword'
              )[0].lanNm // 비밀번호를 입력하세요.
            : ''}
        </Typography>
        <TextField
          fullWidth
          type="password"
          label=""
          value={props.certificationInputs.passwoard}
          onChange={(e) => {
            props.setCertificationInputs({
              ...props.certificationInputs,
              passwoard: e.target.value,
            });
          }}
          onKeyDown={(e) => e.key === 'Enter' && props.SearchLogic1()}
          autoFocus
        />
        <Button
          fullWidth
          name={
            props.lanInfo.length > 0
              ? props.lanInfo.filter((f) => f.lanId === 'Confirm')[0].lanNm // 확인
              : ''
          }
          onClick={() => props.SearchLogic1()}
        />
      </Stack>
    </Box>
  );
}

export default Certification;
